export default Object.freeze({
  TRY: "TRY",
  USD: "USD",
  EUR: "EUR"
});
